/* eslint-disable jsx-a11y/label-has-for */
import React from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";

import { Button, IconButton, Tooltip } from "@toddle-edu/ds-web";
import { EyeOutlined } from "@toddle-edu/ds-icons";

import { colors } from "Constants";
import classes from "./ScreenHeader.scss";
import { ChevronIcon } from "SvgComponents";
import classNames from "classnames";
import _ from "lodash";

export const ScreenHeader = ({
  title,
  isEditMode,
  headerData,
  isPreview,
  changeMode,
  onSave,
  openDiscardDialog,
}) => {
  const { t } = useTranslation(["common", "journal"]);
  const taggedClassNames = _.get(headerData, "taggedClassNames");
  const updatedByName = _.get(headerData, "updatedByName");
  const saveShortcuts = { code: "Enter", shiftKey: true };

  const onBackClick = () => {
    if (isPreview) {
      changeMode("EDIT")();
    } else {
      openDiscardDialog();
    }
  };

  const subTitleClasses = classNames({
    ["text-body-s"]: true,
    [classes.subtitle]: true,
  });

  const titleContainerClasses = classNames({
    [classes.titleLabelContainer]: true,
  });

  return (
    <div
      className={classes.container}
      data-test-id="routine-templates-screenheader-container"
    >
      <div
        className={classes.leftContainer}
        data-test-id="routine-templates-screenheader-left"
      >
        <div
          className={classes.logoContainer}
          data-test-id="routine-templates-screenheader-logo"
        >
          {/* <div onClick={onBackClick} className={classes.chevronIconContainer}>
            <ChevronIcon fill={colors.neutral400} />
          </div> */}
          <IconButton
            className={classes.chevronIconContainer}
            variant="neutral"
            type="plain"
            onClick={onBackClick}
            icon={<ChevronIcon fill={colors.neutral400} />}
            testId="routine-templates-screenheader-back"
          />
          <div className={classes.titleContainer}>
            <h6 className={titleContainerClasses}>
              {isEditMode || isPreview
                ? !_.isEmpty(title)
                  ? title
                  : "Untitled"
                : t("journal:create_routine_template")}
            </h6>
            {isPreview ? (
              <label
                className="text-body-s"
                data-test-id="routine-templates-screenheader-previewlabel"
              >
                {" "}
                {t(`common:preview`)}
              </label>
            ) : null}
            {isEditMode && !isPreview && !_.isEmpty(updatedByName) ? (
              <label className={subTitleClasses}>
                {t(`journal:last_modified_by_name`, {
                  name: updatedByName,
                })}
              </label>
            ) : null}
          </div>
          {isPreview && !_.isEmpty(taggedClassNames) ? (
            <div
              className={classes.courseNames}
              data-test-id="routine-template-screenheader-classes"
            >
              <span className="text-label">
                {_.size(taggedClassNames) > 1
                  ? t("journal:mapped_to_classes", {
                      class1: _.first(taggedClassNames),
                      class2: _.get(taggedClassNames, "[1]"),
                    })
                  : t("journal:mapped_to_single_class", {
                      class1: _.first(taggedClassNames),
                    })}
              </span>
              {_.size(taggedClassNames) > 2 ? (
                <Tooltip
                  tooltip={_.join(_.slice(taggedClassNames, 2), ",")}
                  placement="bottom"
                  overlayInnerStyle={{
                    width: "300px",
                  }}
                >
                  <span
                    className={cn("text-label", { [classes.classCount]: true })}
                  >
                    {t(`journal:count_more_classes`, {
                      count: _.size(taggedClassNames) - 2,
                    })}
                  </span>
                </Tooltip>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
      <div
        className={classes.rightContainer}
        data-test-id="routine-templates-screenheader-right"
      >
        {!isPreview ? (
          <>
            <Button
              variant="neutral"
              type="outlined"
              icon={<EyeOutlined />}
              onClick={changeMode("PREVIEW")}
              size="medium"
              dsVersion="2.0"
              testId="routine-templates-screenheader-preview"
            >
              {t(`common:preview`)}
            </Button>
            <Button
              variant="primary"
              onClick={onSave}
              size="medium"
              dsVersion="2.0"
              shortcut={saveShortcuts}
              testId="routine-templates-screenheader-save"
            >
              {t(`common:save`)}
            </Button>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default ScreenHeader;
